// @flow
import React from 'react';
import ReactionCount from './ReactionCount';

type Props = {
    comment: any
};

const videoUrl = 'https://static.trainheroic.com/images/VideoEmpty.png';

export default function CommentBubble({ comment }: Props) {
    if (!comment) {
        return null;
    }

    const textToDisplay = comment.content && comment.content.split('GIF: ')[0];
    const hasGif = comment.content && comment.content.includes('GIF: ');
    const hasVideo =
        comment.imageUrl &&
        (comment.imageUrl.includes('.mov') ||
            comment.imageUrl.includes('.mp4'));
    const hasImage = comment.imageUrl && !hasVideo;
    const hasMedia = hasImage || hasGif || hasVideo;

    let gifBubble = null;
    if (hasGif) {
        const gifUrl = comment.content.split('GIF: ')[1];
        gifBubble = (
            <div>
                <img src={gifUrl} alt="commentGif" className="comment-image" />
            </div>
        );
    }

    const imageBubble = hasImage ? (
        <div>
            <img
                src={comment.imageUrl}
                alt="commentImage"
                className="comment-image"
            />
        </div>
    ) : null;

    const videoBubble = hasVideo ? (
        <div className="video-container">
            <video className="comment-image">
                <source src={comment.imageUrl} />
            </video>
            <div className="video-overlay" />
        </div>
    ) : null;

    const groupedReactions = {};
    for (let i = 0; i < comment.reactions.length; i++) {
        const reaction = comment.reactions[i];
        if (!groupedReactions[reaction.reactionId]) {
            groupedReactions[reaction.reactionId] = 0;
        }

        groupedReactions[reaction.reactionId]++;
    }
    const reactions = Object.keys(groupedReactions).map(
        (reactionId: number) => (
            <ReactionCount
                id={reactionId}
                count={groupedReactions[reactionId]}
            />
        )
    );

    let reactionBubble = null;
    if (reactions.length) {
        reactionBubble = <div className="reactions">{reactions}</div>;
    }

    const commentClassName = hasMedia ? 'comments' : 'comments no-media';

    return (
        <div className="comment-bubble">
            <div className="profile-image">
                <img alt="user avatar" src={comment.authorLogo} />
            </div>
            <div className={commentClassName}>
                <div className="session-note-title">{comment.authorName}</div>
                {textToDisplay}
            </div>
            {imageBubble}
            {videoBubble}
            {gifBubble}
            {reactionBubble}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/v5/messaging/components/CommentBubble.jsx